import {
  ChartCurve,
  ChartHorizontalAlign,
  ChartPosition,
  ChartShape
} from '@base/@types/components/Layout/Graphic/Info'
import { IGraphicResponse } from '@base/@types/providers/Otb/FollowUpProvider'

export const getStorageSeries = (data: IGraphicResponse) => {
  return [
    {
      name: 'Estoque Open-To-By',
      data: data.desvioMedio.map(item => item.valor)
    }
  ]
}

export const storageOptions = (_data: IGraphicResponse) => {
  return {
    chart: {
      title: {
        text: 'undefined',
        align: 'left',
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
          color: '#263238'
        }
      },
      dropShadow: {
        enabled: true,
        color: '#000',
        top: 10,
        left: 7,
        blur: 8,
        opacity: 0.2
      },
      toolbar: {
        show: true,
        offsetY: -5,
        offsetX: -26
      },
      colors: [
        '#1d5840',
        '#f9e900',
        '#9AE6B4',
        '#ECC94B',
        '#1d5840',
        '#f9e900',
        '#9AE6B4',
        '#ECC94B',
        '#1d5840',
        '#f9e900',
        '#9AE6B4',
        '#ECC94B',
        '#1d5840',
        '#f9e900',
        '#9AE6B4',
        '#ECC94B'
      ]
    },
    colors: [
      '#1d5840',
      '#f9e900',
      '#9AE6B4',
      '#ECC94B',
      '#1d5840',
      '#f9e900',
      '#9AE6B4',
      '#ECC94B',
      '#1d5840',
      '#f9e900',
      '#9AE6B4',
      '#ECC94B',
      '#1d5840',
      '#f9e900',
      '#9AE6B4',
      '#ECC94B'
    ],
    plotOptions: {
      colors: [
        '#1d5840',
        '#f9e900',
        '#9AE6B4',
        '#ECC94B',
        '#1d5840',
        '#f9e900',
        '#9AE6B4',
        '#ECC94B'
      ],
      bar: {
        columnWidth: '45%',
        distributed: true
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: [3],
      curve: ChartCurve.smooth
    },
    markers: {
      size: 3,
      strokeWidth: 0,
      shape: ChartShape.circle,
      hover: {
        size: 6
      }
    },
    xaxis: {
      labels: {
        rotate: 0
      },
      categories: [
        'ESTQ INICIAL',
        'ESTQ ATUAL',
        // 'RECEBIDO MÊS',
        'VD REAL',
        // 'A RECEBER',
        'VD PROJ',
        // 'OTB',
        'ESTQ PLANEJ',
        'QTD RECEBER'
      ]
    },
    yaxis: {
      title: {
        text: 'Valor R$'
      },
      tickAmount: 6,
      labels: {
        formatter: function (val: number) {
          if (val === 0) {
            return '0'
          }
          return val / 10000000 + 'M'
        }
      }
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: [
        {
          formatter: function (y: any) {
            if (typeof y !== 'undefined') {
              return Number(y / 1000).toFixed(2) + 'K'
            }
            return y
          }
        }
      ]
    },
    legend: {
      floating: true,
      position: ChartPosition.top,
      horizontalAlign: ChartHorizontalAlign.center,
      offsetX: 25,
      offsetY: -3
    }
  }
}
